import { Typography } from '@mui/material';
import { InteractiveModal } from 'components/Modals/InteractiveModal/BaseModal';
import ExternalUserHandler from 'handlers/external.user.handler';
import { useTranslation } from 'react-i18next';

export {};

/**
 *
 * The Deactivation modal is a modal that is used to deactivate an External user.
 */

interface Props {
  open: boolean;
  userId: string;
  firstName: string;
  lastName: string;
  handleAbort: () => void;
}

export const ExternalUserDeactivationModal = ({
  open,
  userId,
  firstName,
  lastName,
  handleAbort,
}: Props) => {
  const { t } = useTranslation();
  const userHandler = new ExternalUserHandler();
  const title = `Confirm Deactivation of ${firstName} ${lastName}`;
  const active = false;
  return (
    <InteractiveModal
      initialState={open}
      title={title}
      handleAbort={handleAbort}
      SuccessButtonProps={{
        onClick: async () => {
          await userHandler.deactivateExternalUser(userId, firstName, lastName);
          handleAbort();
        },
        disabled: false,
        label: t('deactivate_user'),
      }}
      ModalContentProps={{
        gridItemProps: {
          lg: 12,
        },
      }}
    >
      <Typography key="blurb-1" variant="medium">
        {t('upon_user_deactivation_this_user_will_no_longer_have_access_')}
      </Typography>
      <Typography key="blurb-2" variant="medium">
        {"To reactivate a user, click the 'Inactive' Link under 'Status'"}
      </Typography>
    </InteractiveModal>
  );
};
